export default __webpack_public_path__ + "static/media/policy03_2023.0a1abb09.jpg";